export const ADMIN_USER_LOGIN_REQUEST = 'ADMIN_USER_LOGIN_REQUEST';
export const ADMIN_USER_LOGIN_SUCCESS = 'ADMIN_USER_LOGIN_SUCCESS';
export const ADMIN_USER_LOGIN_FAIL = 'ADMIN_USER_LOGIN_FAIL';
export const ADMIN_USER_LOGOUT = 'ADMIN_USER_LOGOUT';
export const ADMIN_USER_ADD_POINT = 'ADMIN_USER_ADD_POINT';
